export default function StaticSubmissionInfo({
  message = "Please note that you will not be able to change your Report after submission.",
  className = "mb-0 mt-4"
}: {
  message?: string|JSX.Element;
  className?: string;
}) {
  return <div className={`alert alert-info ${className}`.trim()}>
    {message}
  </div>
}
